import React from "react";
import { MapPin } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

const LANDSCAPE =
  "https://customer-assets.emergentagent.com/job_aceite-granada/artifacts/gy8olc6m_cortijoorigen.jpg";

export default function Origin() {
  const { t } = useLang();
  const paragraphs = t("origin.paragraphs");
  const stats = t("origin.stats");

  return (
    <section
      id="origen"
      data-testid="origin-section"
      className="relative bg-olive-800 text-cream-100 overflow-hidden"
    >
      <div className="absolute inset-0 opacity-55">
        <img
          src={LANDSCAPE}
          alt={t("origin.image_alt")}
          className="h-full w-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-olive-900 via-olive-900/70 to-olive-900/40" />
      </div>

      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-12 py-24 sm:py-32 lg:py-40 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3">
            <MapPin size={14} strokeWidth={1.2} className="text-gold" />
            <span className="text-[11px] uppercase tracking-[0.32em] text-gold font-medium">
              {t("origin.overline")}
            </span>
          </div>
          <h2 className="mt-6 font-serif text-4xl sm:text-5xl lg:text-[56px] leading-[1.05] font-medium">
            {t("origin.h2_a")} <br />
            <span className="italic text-gold">{t("origin.h2_b")}</span>.
          </h2>
        </div>

        <div className="lg:col-span-7 lg:pl-12">
          <div className="space-y-6 text-base sm:text-lg leading-relaxed text-cream-100/85 font-light max-w-xl">
            {paragraphs.map((p) => (
              <p key={p.slice(0, 40)}>{p}</p>
            ))}
          </div>

          <div className="mt-14 grid sm:grid-cols-3 gap-8 max-w-xl">
            {stats.map((s) => (
              <div key={s.k} className="border-t border-cream-100/20 pt-4">
                <div className="font-serif text-2xl">{s.k}</div>
                <div className="text-[11px] uppercase tracking-[0.24em] text-cream-100/60 mt-1">
                  {s.v}
                </div>
              </div>
            ))}
          </div>

          <div className="mt-10 inline-flex items-center gap-2 border border-gold/50 px-4 py-2 rounded-full">
            <span className="w-1.5 h-1.5 bg-gold rounded-full" />
            <span className="text-[11px] uppercase tracking-[0.28em] text-gold">
              {t("origin.badge")}
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
